var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { Button, FormField } from '@cloudscape-design/components';
export default function ActionButtonComponent(_a) {
    var uiInput = _a.uiInput, disabled = _a.disabled, onActionButtonClick = _a.onActionButtonClick;
    /**
     * Executes the function on button click.
     */
    var onClick = function () {
        if (onActionButtonClick) {
            onActionButtonClick(uiInput);
        }
    };
    return (_jsx(FormField, __assign({ description: uiInput.Description, label: uiInput.Label }, { children: _jsx(Button, __assign({ disabled: disabled, onClick: onClick, iconName: uiInput === null || uiInput === void 0 ? void 0 : uiInput.IconName }, { children: uiInput.ButtonText })) })));
}
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiQWN0aW9uQnV0dG9uQ29tcG9uZW50LmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vLi4vc3JjL2xpYi9jb21wb25lbnRzL0FjdGlvbkJ1dHRvbkNvbXBvbmVudC50c3giXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7Ozs7Ozs7Ozs7O0FBQUEsT0FBTyxFQUFFLE1BQU0sRUFBRSxTQUFTLEVBQUUsTUFBTSwrQkFBK0IsQ0FBQztBQVVsRSxNQUFNLENBQUMsT0FBTyxVQUFVLHFCQUFxQixDQUFDLEVBQTZEO1FBQTNELE9BQU8sYUFBQSxFQUFFLFFBQVEsY0FBQSxFQUFFLG1CQUFtQix5QkFBQTtJQUNwRjs7T0FFRztJQUNILElBQU0sT0FBTyxHQUFHO1FBQ2QsSUFBSSxtQkFBbUIsRUFBRTtZQUN2QixtQkFBbUIsQ0FBQyxPQUFPLENBQUMsQ0FBQztTQUM5QjtJQUNILENBQUMsQ0FBQztJQUVGLE9BQU8sQ0FDTCxLQUFDLFNBQVMsYUFBQyxXQUFXLEVBQUUsT0FBTyxDQUFDLFdBQVcsRUFBRSxLQUFLLEVBQUUsT0FBTyxDQUFDLEtBQUssZ0JBQy9ELEtBQUMsTUFBTSxhQUFDLFFBQVEsRUFBRSxRQUFRLEVBQUUsT0FBTyxFQUFFLE9BQU8sRUFBRSxRQUFRLEVBQUUsT0FBTyxhQUFQLE9BQU8sdUJBQVAsT0FBTyxDQUFFLFFBQVEsZ0JBQ3RFLE9BQU8sQ0FBQyxVQUFVLElBQ1osSUFDQyxDQUNiLENBQUM7QUFDSixDQUFDIn0=